import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { DisclaimersComponent } from './disclaimers.component';
import { SharedModule } from '../../shared/shared.module';

export const COMPONENTS = [
    DisclaimersComponent
];

@NgModule({
  declarations: COMPONENTS,
  imports: [
    CommonModule,
    SharedModule
  ],
  exports: COMPONENTS,
  providers: [],
  bootstrap: [],
})
export class DisclaimersModule {
}
